module.exports = __webpack_public_path__ + "static/media/bytt-no-6.e825933e.mp3";